import { IsoDateCodec } from '@/pages/OperationsAdministration/types/Api/IsoDateCodec';
import { z } from 'zod';

export const WorkstreamDefinitionAdvancedSnapshotSchema = z.object({
    isEnabled: z.optional(z.boolean()),
    lastRunAt: z.optional(IsoDateCodec),
    nextRunAt: z.optional(IsoDateCodec),
    enabledAt: z.optional(IsoDateCodec)
});
export type WorkstreamDefinitionAdvancedSnapshot = z.infer<typeof WorkstreamDefinitionAdvancedSnapshotSchema>;
